// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-dialog[data-v-07d558fa] {\n  --mdc-dialog-max-width: 454px;\n}\n", ""]);
// Exports
module.exports = exports;
